import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Button } from 'antd';
import { spacing } from './../../../theming';
import { useMedia } from '../../../hooks/useMediaQuery';

export default function EditContainer({ children, input, submit, isAvatar }) {
    const [show, setShow] = useState({
        editButton: false,
        editForm: false,
    });
    const [isHovered, setIsHovered] = useState(false);
    const [throttle, setThrottle] = useState(false); // for smoother animation

    const { isSmallDevice } = useMedia();

    const handleShow = element => {
        if (!isSmallDevice || !throttle) {
            if (!isSmallDevice) {
                setThrottle(true);
            }

            setShow(prev => ({
                ...prev,
                [element]: !prev[element],
            }));

            if (!isSmallDevice) {
                setTimeout(() => setThrottle(false), 300);
            }
        }
    };

    return (
        <motion.div
            style={{
                position: 'relative',
                width: 'fit-content',
                cursor: show.editButton && 'pointer',
            }}
            onMouseEnter={() => {
                if (!isSmallDevice) {
                    setIsHovered(true);
                    handleShow('editButton');
                }
            }}
            onMouseLeave={() => {
                if (!isSmallDevice) {
                    setIsHovered(false);
                    handleShow('editButton');
                }
            }}
            onTouchStart={() => {
                setIsHovered(prev => !prev);
                handleShow('editButton');
            }}
        >
            {show.editForm ? input : children}
            <AnimatePresence>
                {(isHovered || (show.editForm && isAvatar)) && (
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -20 }}
                        transition={{ duration: 0.2 }}
                        style={{
                            position: 'absolute',
                            top: -4,
                            right: -40,
                        }}
                    >
                        <Button
                            shape="circle"
                            type="text"
                            onClick={() => {
                                handleShow('editForm');
                                if (show.editForm) {
                                    submit();
                                }
                            }}
                        >
                            {
                                <i
                                    className={show.editForm ? 'fi-rr-cross' : 'fi-rr-edit'}
                                    style={{ marginTop: spacing[0.5] }}
                                />
                            }
                        </Button>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}
